module.exports = __webpack_public_path__ + "img/turtle.affc9610.svg";